import { css } from 'emotion';
import { Device } from '.';
import { animationTransition, colors } from '@joykit/variables';

export const DEVICE_DIMENSIONS: {
  [device in Device]: {
    width: number;
    height: number;
  }
} = {
  monitor: { width: 1440, height: 900 },
  tablet: { width: 768, height: 1024 },
  phone: { width: 375, height: 667 }
};

export namespace styles {
  export const previewWrapper = css({
    display: 'flex',
    justifyContent: 'center',
    height: '100%'
  });

  export const iframeWrapper = (device: Device, iframeWidth: number = 1600, iframeHeight = 900) => {
    const { width, height } = DEVICE_DIMENSIONS[device];
    const widthScale = iframeWidth / width;
    const heightScale = iframeHeight / height;
    const scale = Math.min(widthScale, heightScale);
    return css({
      height: '100%',
      transform: `translateY(-24px) scale(${scale > 1 ? 1 : scale})`
    });
  };

  export const iframe = css({
    width: '1px !important',
    minWidth: '100%',
    height: '1px !important',
    minHeight: '100%',
    backgroundColor: 'white'
  });

  const getDeviceShellContainerStyles = (device: Device, deviceShell: boolean) => {
    const { width, height } = DEVICE_DIMENSIONS[device];
    switch (device) {
      case 'monitor':
        return { paddingTop: 40, height, width, margin: '0 auto' };
      case 'phone':
        return { width, height, padding: '60px 8px 40px' };
      default:
        return { width, height };
    }
  };

  export const container = (fading: boolean, device: Device, deviceShell: boolean, hasInitialized: boolean) => {
    const deviceStyles = getDeviceShellContainerStyles(device, deviceShell);
    return css(
      {
        opacity: 1,
        position: 'absolute',
        left: '50%',
        top: '50%',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px',
        transform: 'translate(-50%, -50%)',
        transition: animationTransition('opacity'),
        boxShadow: '0px 1px 5px rgba(0,0,0,0.1)',
        backgroundColor: hasInitialized ? undefined : '#FFF'
      },
      fading
        ? {
            opacity: 0
          }
        : undefined,
      deviceStyles
    );
  };

  export const monitorShell = css({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '40px',
    backgroundColor: 'white',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    display: 'flex',
    alignItems: 'center'
  });

  export const monitorCircle = css({
    height: 16,
    width: 16,
    borderRadius: '50%',
    marginLeft: 8,
    ':nth-child(1)': {
      backgroundColor: '#FF6159',
      marginLeft: 32
    },
    ':nth-child(2)': {
      backgroundColor: '#FFBF2F'
    },
    ':nth-child(3)': {
      backgroundColor: '#29CD42'
    }
  });

  //

  export const phoneShell = css({
    position: 'absolute',
    top: 0,
    height: '700px',
    width: '375px',
    left: '0px',
    backgroundColor: 'white',
    zIndex: -1,
    borderRadius: '20px'
  });
  export const phoneTop = css({
    position: 'absolute',
    transform: 'translateX(-50%)',
    top: '28px',
    left: '50%'
  });
  export const phoneCamera = css({
    backgroundColor: colors.light,
    height: 6,
    width: 6,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '8px'
  });
  export const phoneSpeaker = css({
    width: '40px',
    height: 6,
    backgroundColor: colors.light,
    display: 'inline-block',
    borderRadius: 6
  });
  export const phoneTrackpad = css({
    position: 'absolute',
    bottom: '15px',
    height: '45px',
    width: '45px',
    borderRadius: '50%',
    backgroundColor: colors.light,
    left: '50%',
    transform: 'translateX(-50%)'
  });
}
